@if (!submitted) {
<app-fp-edit (formDataOutput)="getChildFormData($event)" [serverError]="serverError"> </app-fp-edit>
} @if (submitted) {
<app-fp-confirmation [resetPasswordLink]="resetPasswordLink" [emailAddress]="usernameOrEmail"></app-fp-confirmation>
}
